/**
 * 开票详情
 */
<template>
  <div>
    <div class="content-container">
      <!-- 面包屑导航 -->
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
        <el-breadcrumb-item :to="{ path: '/payCenter/invoiceRecord' }"
          >财务中心</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/payCenter/invoiceRecord' }"
          >开票申请</el-breadcrumb-item
        >
        <el-breadcrumb-item>开票详情</el-breadcrumb-item>
      </el-breadcrumb>

      <!--列表-->
      <el-table
        size="small"
        :data="listData"
        highlight-current-row
        v-loading="loading"
        element-loading-text="拼命加载中"
        style="width: 100%"
        class="table"
      >
        <el-table-column prop="id" fixed label="详情id"> </el-table-column>
        <el-table-column prop="invoiceDate" label="开票日期"> </el-table-column>
        <el-table-column prop="invoiceStyle" label="发票样式">
        </el-table-column>
        <el-table-column prop="" label="发票">
          <template slot-scope="scope">
            <el-link
              type="primary"
              @click="opendetails(scope.row.invoiceDownloadUrl)"
              >查看</el-link
            >
          </template>
        </el-table-column>
        <el-table-column label="发票状态">
          <template slot-scope="scope">
            <span :style="getStatusStyle(scope.row.invoiceStatus)">
              {{ scope.row.invoiceStatus }}
            </span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作">
          <template #default="scope">
            <el-button
              size="small"
              text
              type="danger"
              @click="onDeletInvoiceDtl(scope.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { invoicedetails, deleteInvoiceDtl } from "../../api/userMG";
import { Message, MessageBox } from "element-ui";
export default {
  data() {
    return {
      listData: [],
      loading: false,
    };
  },
  // 注册组件
  components: {},
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getinvoicedetails(this.$route.query.id);
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    opendetails(url) {
      if (!url) {
        this.$message.error("发票正在生成上传中，请稍后重试");
        return;
      }
      window.open(url);
    },
    getinvoicedetails(id) {
      this.loading = true;
      invoicedetails(id)
        .then((res) => {
          if (res.msg != "success") {
            this.$message({
              type: "error",
              message: res.msg,
            });
            this.loading = false;
          } else {
            this.loading = false;
            this.info = res.data;
            this.listData = res.data.invoiceDetailList;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    onDeletInvoiceDtl(id) {
      MessageBox.confirm(`此操作将上传开票删除，是否继续?`, "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "error",
      })
        .then(() => {
          deleteInvoiceDtl({ id: id })
            .then((response) => {
              if (response.msg == "success") {
                this.$message({
                  type: "success",
                  message: "删除成功",
                });
                this.getinvoicedetails(this.$route.query.id);
              } else {
                this.$message({
                  type: "error",
                  message: response.msg,
                });
              }
            })
            .catch(() => {
              this.getinvoicedetails(this.$route.query.id);
            });
        })
        .catch(() => {});
    },
    getStatusStyle(status) {
      const colorMap = {
        红冲发票: "color: red; font-weight: bold",
        作废发票: "color: gray; text-decoration: line-through",
        正常发票: "color: green",
      };
      return colorMap[status] || ""; // 未知状态返回空样式
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
  margin-bottom: 10px;
  padding: 10px;
  background-color: #fff;
}
.el-form-item {
  margin-bottom: 10px !important;
}
.userRole {
  width: 100%;
}

/* 面包屑导航样式 */
.breadcrumb {
  margin-bottom: 25px; /* 与表格之间的间距 */
}
</style>

 


// WEBPACK FOOTER //
// src/views/payCenter/invoiceRecordDtl.vue